import { makeStyles } from '@material-ui/core';
import { vw } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../mui-theme';

export const styles = makeStyles(theme => ({
  dialogPaperFullWidth: {
    maxWidth: '64.72vw',
  },
  title: {
    display: 'flex',
    fontWeight: 500,
    fontStretch: 'normal',
    lineHeight: '1.17',
    letterSpacing: 0.43,
    fontSize: vw(2.34),
    margin: '6.5104166666667vh auto 0 auto',
    color: theme.palette.primary.main,
  },
  voidedItems: {
    height: '18.0vh',
    marginLeft: '8.20vw',
    '@media (aspect-ratio: 4/3)': {
      height: '16.5vh',
    },
  },
  arrows: {
    margin: 'auto',
    width: '20%',
    '@media (aspect-ratio: 4/3)': {
      paddingTop: '3.90625vh',
    },
  },
  itemList: {
    paddingBottom: '1.32vh',
  },
  messageLine: {
    display: 'flex',
    alignItems: 'flex-start',
    overflow: 'hidden',
    lineHeight: '1.56',
    color: themeColor.blackish,
    fontSize: vw(1.32),
    marginBlockStart: 0,
    marginBlockEnd: 0,
    fontWeight: 500,
    marginTop: '3.78vh',
  },
  icon: {
    width: '2.05vw',
    height: '3.24vh',
    display: 'flex',
    marginRight: 7,
    color: themeColor.alert,
  },
}));
